import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQSection from '../components/sections/FAQSection';

const FAQPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <main className="pt-20">
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
